import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default class ModaleSuppression extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.closedeleteModal = this.closedeleteModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  closedeleteModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModaleSuppression();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  handleDelete = () => {
    this.setState({ styleFadeIn: false });
    this.props.onSubmitSuppression();
  };

  render() {
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin show actif"
          id="modalDelete"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closedeleteModal}
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">Supprimer une publication</h5>
                  </section>
                  <section>
                    <h5>
                      Vous souhaitez supprimer définitivement la publication?
                    </h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                        onClick={this.handleDelete}
                      >
                        <img
                          src="img/icon-check-white.svg"
                          class="img-fluid"
                          alt=""
                        />{" "}
                        Confirmer
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
